module.exports = __webpack_public_path__ + "img/1462457292.761ad26f.jpg";